export default __webpack_public_path__ + "static/media/Default-Image.d0c4cd57.jpg";